import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const NotebookHeart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 8.5h4.865M3 12.5h4.865M3 16.5h4.865M15.59 10a1.52 1.52 0 0 0-1.4.942A1.52 1.52 0 0 0 12.785 10a1.656 1.656 0 0 0-1.516 1.674c0 1.834 2.53 3.326 2.92 3.326.388 0 2.918-1.492 2.918-3.326A1.66 1.66 0 0 0 15.59 10M8.351 21h9.73C19.693 21 21 19.657 21 18V6c0-1.657-1.307-3-2.919-3h-9.73C6.74 3 5.432 4.343 5.432 6v12c0 1.657 1.307 3 2.92 3"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(NotebookHeart) as SvgIcon;
export { ForwardRef as ReactComponent };
